import { benefits } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function BenefitsSection() {
  return (
    <section className="relative py-16 md:py-20 lg:py-24 bg-background-100">
      <div className="absolute inset-0 z-0 opacity-[0.03]">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20watercolor%20texture%20with%20gentle%20warm%20beige%20and%20cream%20washes%20flowing%20into%20each%20other%2C%20subtle%20organic%20patterns%2C%20light%20airy%20background%2C%20minimal%20abstract%20art%2C%20fine%20paper%20texture%2C%20clean%20modern%20design%20element%2C%20peaceful%20calming%20aesthetic%2C%20neutral%20warm%20tones&width=1920&height=800&seq=benefits-bg-new-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              Dlaczego USFans Spreadsheet
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-tight">
              Kompleksowe narzędzie do zarządzania arkuszami kalkulacyjnymi
            </h2>
            <p className="text-foreground-500 mt-4 text-sm md:text-base leading-relaxed max-w-lg">
              USFans Spreadsheet to zaawansowane narzędzie, które łączy funkcjonalność tradycyjnych arkuszy z nowoczesnymi możliwościami analizy danych. Zostało zaprojektowane z myślą o użytkownikach poszukujących wydajnego rozwiązania.
            </p>

            <div className="mt-8 space-y-4">
              {benefits.map((benefit) => (
                <div key={benefit.title} className="flex gap-4 items-start">
                  <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${benefit.icon} text-primary-600 text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground-800 text-sm md:text-base">{benefit.title}</h3>
                    <p className="text-foreground-500 text-xs md:text-sm mt-1 leading-relaxed">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <Link
                to="/artykul/usfans-spreadsheet-kompletny-przewodnik"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-foreground-900 text-white text-sm font-medium hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Przeczytaj pełny przewodnik
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/3] rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20modern%20home%20office%20with%20large%20monitor%20showing%20colorful%20data%20dashboard%2C%20warm%20natural%20light%20from%20large%20window%20overlooking%20garden%2C%20light%20oak%20desk%20with%20minimal%20accessories%2C%20cream%20linen%20chair%2C%20indoor%20plant%20in%20terracotta%20pot%2C%20warm%20and%20inviting%20productivity%20space%2C%20sophisticated%20interior%20design%2C%20editorial%20quality%20photography%2C%20soft%20neutral%20tones&width=800&height=600&seq=benefits-img-new-2026&orientation=landscape"
                alt="USFans Spreadsheet - nowoczesne narzędzie"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-2xl border border-background-200/70 px-4 py-3 flex items-center gap-3 shadow-sm">
              <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-star-fill text-accent-500 text-sm"></i>
              </div>
              <div>
                <p className="text-xs font-semibold text-foreground-800">4.9 / 5.0</p>
                <p className="text-xs text-foreground-500">Ocena użytkowników</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}